"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSources = void 0;
const generic_browser_lib_1 = require("@squiz/generic-browser-lib");
/**
 * Loads and caches the source list when a component using the hook is mounted.
 */
const useSources = ({ onRequestSources, plugins }) => {
    const pluginsKey = plugins.reduce((acc, plugin) => acc + plugin.type, '');
    return (0, generic_browser_lib_1.useAsync)({
        callback: () => {
            return new Promise((resolve, reject) => {
                // Get all the sources from the outer context
                onRequestSources()
                    .then((sources) => {
                    // Remove any sources which we don't have a plugin to handle
                    const filteredSources = sources.filter((source) => {
                        return !!plugins.find((plugin) => {
                            if (plugin.type === source.type) {
                                return true;
                            }
                            return false;
                        });
                    });
                    // Attach the plugin to the source so it can be quickly used later
                    const combinedSources = filteredSources.map((source) => {
                        const plugin = plugins.find((plugin) => {
                            if (plugin.type === source.type) {
                                return true;
                            }
                            return false;
                        });
                        return {
                            ...source,
                            plugin,
                        };
                    });
                    resolve(combinedSources);
                })
                    .catch((e) => {
                    reject(e);
                });
            });
        },
        defaultValue: [],
    }, [onRequestSources, pluginsKey]);
};
exports.useSources = useSources;
